

const swatchItems = document.querySelectorAll( '[data-sync-select]' );

// @ts-ignore
swatchItems.forEach( option => option.addEventListener( 'input', swatchInputHandler ) );


/**
 * Syncs the select element with the name specified in the data-sync-select attribute with the selected swatch item
 *
 * @param {InputEvent} e
 *
 * @return void
 */
function swatchInputHandler( e ) {
    const option = /** @type {HTMLInputElement} */ ( e.currentTarget );
    const name = option.getAttribute( 'data-sync-select' );
    const value = option.value;
    const targets = option.closest( 'form' )?.querySelectorAll( `select[name=${name}]` ) ?? [];
    targets.forEach( target => selectOption( target, value ) );
}


/**
 * Changes the value of a select dropdown, and triggers the change event
 *
 * @param {HTMLSelectElement} select
 * @param {string} value
 */
function selectOption( select, value ) {
    if ( select.value === value ) return;
    select.value = value;
    // Trigger woocommerce variation handling
    jQuery( select ).change();
}